<template>
    <div id="ActSubmit">
        <v-loading v-if="loading"></v-loading>
        <template v-else>
            <Forward @forward="$router.push({ name: 'admin-payouts' })" />
            <div class="title">Информация по запросу на выплату</div>
            <div class="balance-text" v-if="data">
                Сумма на выплату - <span>{{ data.amount }} руб.</span>
            </div>
            <div class="btn-group">
                <v-button @click="submitForm">Выплатить</v-button>
                <v-button custom-type="text" custom-style="primary" @click="declineForm">Отклонить</v-button>
            </div>
            <ContainerSlot v-if="data" :isCompleted="true">
                <div class="title">Контактные данны</div>
                <div class="input-container">
                    <div class="input-block">
                        <v-input
                            name="name"
                            title="ФИО"
                            rules="required"
                            v-model="data.contract.name"
                            :disabled="true"
                        />
                        <button type="button" class="input-btn-icon" @click="copy(data.contract.name)">
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                    <div class="input-block">
                        <v-phone-mask
                            name="phone"
                            title="Контактный телефон"
                            rules="required"
                            v-model="data.contract.phone"
                            :disabled="true"
                        />
                        <button type="button" class="input-btn-icon" @click="copy(data.contract.phone)">
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                    <div class="input-block">
                        <v-input
                            name="email"
                            title="Email"
                            rules="required"
                            v-model="data.contract.email"
                            :disabled="true"
                        />
                        <button type="button" class="input-btn-icon" @click="copy(data.contract.email)">
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                </div>
                <div class="title">Паспортные данные</div>
                <div class="input-container">
                    <div class="input-block">
                        <div class="input-block bigger">
                            <v-input
                                name="passport_serial"
                                title="Номер серии"
                                rules="required"
                                v-model="data.contract.passport_serial"
                                :disabled="true"
                            />
                            <button type="button" class="input-btn-icon" @click="copy(data.contract.passport_serial)">
                                <v-icon src="copyLink" />
                            </button>
                        </div>
                        <div class="input-block smaller">
                            <v-input
                                name="passport_code"
                                title="Код паспорта"
                                rules="required"
                                v-model="data.contract.passport_code"
                                :disabled="true"
                            />
                            <button type="button" class="input-btn-icon" @click="copy(data.contract.passport_code)">
                                <v-icon src="copyLink" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="title">Оплата по акту</div>
                <v-textarea v-model="data.payment_by_act_caption" name="payment_by_act_caption" :disabled="true" />
                <div class="title">Личный ИНН</div>
                <div class="input-container">
                    <div class="input-block">
                        <v-input
                            name="inn_of_legal_entity"
                            title="ИНН юредического лица"
                            rules="required"
                            v-model="data.contract.inn_of_legal_entity"
                            :disabled="true"
                        />
                        <button type="button" class="input-btn-icon" @click="copy(data.contract.inn_of_legal_entity)">
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                    <div class="input-block">
                        <v-input
                            name="inn_serial_and_number"
                            title="Серия и номер (опционально)"
                            rules="required"
                            v-model="data.contract.inn_serial_and_number"
                            :disabled="true"
                        />
                        <button type="button" class="input-btn-icon" @click="copy(data.contract.inn_serial_and_number)">
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                </div>
                <div class="title">Банковские данные</div>
                <div class="input-container">
                    <div class="input-block">
                        <v-input
                            name=""
                            title="Разсчетный счет"
                            rules="required"
                            v-model="data.contract.bank_payment_account"
                            :disabled="true"
                        />
                        <button type="button" class="input-btn-icon" @click="copy(data.contract.bank_payment_account)">
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                    <div class="input-block">
                        <v-input
                            name=""
                            title="Кореспондентский счет"
                            rules="required"
                            v-model="data.contract.bank_correspondent_account"
                            :disabled="true"
                        />
                        <button
                            type="button"
                            class="input-btn-icon"
                            @click="copy(data.contract.bank_correspondent_account)"
                        >
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                    <div class="input-block">
                        <v-input
                            name=""
                            title="БИК"
                            rules="required"
                            v-model="data.contract.bank_identification_code"
                            :disabled="true"
                        />
                        <button
                            type="button"
                            class="input-btn-icon"
                            @click="copy(data.contract.bank_identification_code)"
                        >
                            <v-icon src="copyLink" />
                        </button>
                    </div>
                </div>
            </ContainerSlot>
        </template>
    </div>
</template>

<script>
import { api } from "../../services/api";
export default {
    name: "ActSubmit",
    components: {
        Forward: () => import("../../../payments/components/UI/Forward"),
        ContainerSlot: () => import("../../../payments/components/UI/ContainerSlot"),
        VButton: () => import("../../../../common/components/VButton")
    },
    data() {
        return {
            data: null,
            loading: true
        };
    },
    created() {
        api.payments.acts
            .getAct(this.$route.params.id)
            .then(data => {
                this.data = data.data.data;
                this.loading = false;
            })
            .catch(e => {
                console.log(e);
            });
    },
    methods: {
        submitForm() {
            api.payments.acts
                .changeActStatus(this.$route.params.id, { status: "paid" })
                .then(() => {
                    this.$router.push({ name: "admin-payouts" });
                })
                .catch(e => {
                    console.log(e);
                });
        },
        declineForm() {
            api.payments.acts
                .changeActStatus(this.$route.params.id, { status: "rejected" })
                .then(() => {
                    this.$router.push({ name: "admin-payouts" });
                })
                .catch(e => {
                    console.log(e);
                });
        },
        copy(data) {
            this.$copyText(data);
        }
    }
};
</script>

<style lang="scss">
#ActSubmit {
    font-family: "Roboto", sans-serif;
    //padding: 48px 10px 58px;
    max-width: 900px;
    width: 100%;
    //margin: 0 auto;
    .title {
        font-weight: bold;
        font-size: 28px;
        line-height: 40px;
        color: #1d2228;
        @media (max-width: 769px) {
            font-size: 20px;
        }
    }
    .subtitle {
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;
        color: #1d2228;
        margin-bottom: 5px;
        @media (max-width: 769px) {
            font-size: 16px;
        }
    }

    .balance-text {
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: #58606e;
        margin-top: 16px;
        margin-bottom: 16px;
        span {
            color: black;
        }
    }
    .text {
        font-size: 14px;
        line-height: 20px;
        color: #58606e;
        @media (max-width: 769px) {
            font-size: 12px;
        }
    }
    .form-group input[disabled] {
        color: #1d2228;
        background: transparent;
        border: 1px solid #c8d1e0;
    }
    .btn-group {
        display: flex;
        align-items: center;
        margin-top: 24px;
        margin-bottom: 48px;
        button {
            margin: 0;
        }
        button:first-child {
            margin-right: 25px;
        }
    }
    .input-block {
        position: relative;
        svg {
            fill: #ffc107;
            font-size: 20px;
        }
    }
    .container-slot {
        padding: 0;
    }
}
</style>
